import request from "../../utils/request";
import { Result } from "../../models/general";

export interface PayrollReportInput {
    fromDate: string;
    toDate: string;
    departmentIds?: number[];
    currencyId: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface PayrollSummaryView {
    departmentName: string;
    departmentId: number;
    month: string;
    grossTotal: number;
    deductionsTotal: number;
    netTotal: number;
    overtimeTotal: number;
    variablePayTotal: number;
    headcount: number;
}

export interface SalaryRegisterView {
    employeeId: string;
    employeeName: string;
    departmentName: string;
    grossSalary: number;
    deductions: number;
    variablePay: number;
    overtime: number;
    adjustments: number;
    netPay: number;
    currencyCode: string;
}

export interface DepartmentCostView {
    departmentName: string;
    departmentId: number;
    month: string;
    totalCost: number;
    headcount: number;
    avgSalary: number;
}

export async function getPayrollSummary(input: PayrollReportInput): Promise<Result<PayrollSummaryView[]>> {
    const response = await request.post<Result<PayrollSummaryView[]>>("PayrollReports/GetPayrollSummary", input);
    return response.data;
}

export async function getSalaryRegister(input: PayrollReportInput): Promise<Result<SalaryRegisterView[]>> {
    const response = await request.post<Result<SalaryRegisterView[]>>("PayrollReports/GetSalaryRegister", input);
    return response.data;
}

export async function getDepartmentCost(input: PayrollReportInput): Promise<Result<DepartmentCostView[]>> {
    const response = await request.post<Result<DepartmentCostView[]>>("PayrollReports/GetDepartmentCost", input);
    return response.data;
}
